"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeBasketItemHandler = removeBasketItemHandler;
var RemoveBasketItemFailed = _interopRequireWildcard(require("@ori-events/remove-basket-item-failed"));
var _checkoutUtils = require("@ori/checkout-utils");
var _types = require("../types");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
async function removeBasketItemHandler({
  detail: {
    lineNumber,
    placement
  }
}) {
  const response = await fetch(_types.RequestUrl.RemoveBasketItem, (0, _utils.getHttpRequestSettings)({
    lineNumber,
    placement
  }, _checkoutUtils.HttpMethod.Post));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if (RemoveBasketItemFailed.isRemoveBasketItemErrorResponse(data)) {
    const errorEvent = new CustomEvent(RemoveBasketItemFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}
